export default {
  engagementCategoryTitleRules: (state) => (categoryType) => {
    return state.engagementCategoryTitleRules[categoryType] || [];
  },
};

